import isValidDomain from 'is-valid-domain'

import { Button, ButtonVariant, CheckOrCross, SimpleInput } from '@makyoapp/makyo-ui'

import useDomainField from '../../hooks/components/useDomainField'

interface DomainName {
  domain: string
  verified: boolean
}

interface DomainFieldProps {
  onSave: (value: DomainName) => void
  onCancel: () => void
}

function DomainField(props: DomainFieldProps) {
  const { t, domain, error, formId, disableSubmit, isLoading, setDomain, setError, reset, isExists, handleSubmit } =
    useDomainField()

  return (
    <div>
      <form id={formId} onSubmit={handleSubmit} className='w-full flex-c mt-4'>
        <SimpleInput
          value={domain}
          inputClassName='min-w-0'
          onChange={(e) => {
            const val = e.currentTarget.value
            if (isExists(val)) {
              setError(t('Domain exists'))
            } else {
              setError(undefined)
            }
            setDomain(val)
            //setDomainInput(val)
          }}
          after={
            !domain ? (
              <div className='w-6 h-6' />
            ) : (
              <CheckOrCross
                value={!Boolean(error) && !isExists(domain) && isValidDomain(domain, { subdomain: true })}
              />
            )
          }
        />

        <div className='flex-c'>
          <Button className='h-9' disabled={disableSubmit || isLoading} type='submit'>
            {!isLoading ? t('Save') : <span className='loading' />}
          </Button>
          <Button
            disabled={isLoading}
            className='h-9'
            onClick={() => {
              reset()
              props.onCancel()
            }}
            variant={ButtonVariant.Ghost}
          >
            {t('Cancel')}
          </Button>
        </div>
      </form>
      {error && <div className='red text-m-sm px-2 pt-2'>{error}</div>}
    </div>
  )
}

export default DomainField
